module.exports = __webpack_public_path__ + "img/mile3-m@2.f5981318.webp";